import { useState } from "react";

import { BRANDS, useBrand } from "./index";

/**
 * Panel flotante para comparar las cinco marcas en vivo.
 * Es una herramienta de decisión, no parte del sitio: se quita cuando
 * Christian elija el nombre definitivo.
 */
const BrandSwitcher = () => {
  const { id, idea, setBrand } = useBrand();
  const [open, setOpen] = useState(true);

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-[100] rounded-full bg-[var(--gm-deep)] px-5 py-3 text-xs uppercase tracking-[0.2em] text-[var(--gm-on-deep)] shadow-lg"
        data-testid="brand-switcher-open"
      >
        Marcas
      </button>
    );
  }

  return (
    <div
      className="fixed bottom-6 right-6 z-[100] w-[22rem] max-w-[calc(100vw-3rem)] rounded-sm border border-[var(--gm-vidrio)] bg-[var(--gm-surface-90)] p-5 shadow-[0_30px_60px_rgba(11,22,44,0.18)] backdrop-blur-xl"
      data-testid="brand-switcher"
    >
      <div className="flex items-start justify-between">
        <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-[var(--gm-accent)]">
          Elige la marca
        </p>
        <button
          onClick={() => setOpen(false)}
          className="-mt-1 text-lg leading-none text-[var(--gm-faint)] hover:text-[var(--gm-ink)]"
          aria-label="Cerrar"
        >
          ×
        </button>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-x-2 gap-y-0.5 max-h-[52vh] overflow-y-auto">
        {BRANDS.map((b) => {
          const active = b.id === id;
          return (
            <button
              key={b.id}
              onClick={() => setBrand(b.id)}
              className={`flex w-full items-center gap-2.5 rounded-sm px-2.5 py-2 text-left transition-colors ${
                active ? "bg-[var(--gm-deep)] text-[var(--gm-on-deep)]" : "text-[var(--gm-ink)] hover:bg-[var(--gm-ink-05)]"
              }`}
              data-testid={`brand-option-${b.id}`}
            >
              <b.Mark className="w-5 h-5 shrink-0" reverse={active} />
              <span className="font-serif-display text-[15px] font-semibold leading-tight">
                {b.name} <span className="font-light opacity-70">{b.suffix}</span>
              </span>
            </button>
          );
        })}
      </div>

      <p className="mt-4 border-t border-[var(--gm-line-faint)] pt-3 text-xs font-light leading-relaxed text-[var(--gm-muted)]">
        {idea}
      </p>
    </div>
  );
};

export default BrandSwitcher;
